
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightRainShowersSunColour as ObiLightRainShowersSunColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-rain-showers-sun-colour.js';
 
 
 

 
 export const ObiLightRainShowersSunColour = createComponent({
   react: React,
   tagName: 'obi-light-rain-showers-sun-colour',
   elementClass: ObiLightRainShowersSunColourElement,
   events: {
     
   }
  });
 
 